import { createStore, applyMiddleware } from "redux";
import rootReducer from "./reducers/rootReducer";
import thunk from 'redux-thunk';
import logger from "redux-logger";
import api from "./api";

const store = createStore(rootReducer, applyMiddleware(thunk.withExtraArgument(api), logger));

export default store;
